import { defineComponent as _defineComponent } from 'vue'
export interface Props {
	size?: string | number;
	width?: string | number;
	indeterminate?: boolean;
	color?: string;
	classes?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSpinnerLoader',
  props: {
    size: { default: 70 },
    width: { default: 7 },
    indeterminate: { type: Boolean, default: true },
    color: { default: "secondary" },
    classes: { default: "d-block mx-auto my-4" }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})